
export default {

    get(key) {
        setTimeout(() => {
            let item = localStorage.getItem(key);
        }, 150);
        return localStorage.getItem(key) ? localStorage.getItem(key) : null
    },

    set(key, val) {
        localStorage.setItem(key, val)
    },

    remove(key) {
        localStorage.removeItem(key)
    },

    getSession(key) {
        return sessionStorage.getItem(key) ? sessionStorage.getItem(key) : null;
    },

    setSession(key, val) {
        sessionStorage.setItem(key, val);
    },

    removeSession(key) {
        sessionStorage.removeItem(key);
    }

}


// WEBPACK FOOTER //
// ./src/assets/services/ls.js